import { render } from "./clients-filter.vue?vue&type=template&id=58c6da4c"
import script from "./clients-filter.vue?vue&type=script&lang=js"
export * from "./clients-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__